import React from 'react';

function Hero() {
  return (
    <section id="home" className="relative overflow-hidden bg-[radial-gradient(circle_at_top,_#F5E0D3,_transparent_55%),linear-gradient(180deg,#B91C1C_0%,#7C2D12_100%)] text-white py-20 md:py-28">
      <div className="absolute inset-0 opacity-20 bg-[url('https://images.unsplash.com/photo-1525755662778-989d0524087e?auto=format&fit=crop&w=1200&q=80')] bg-cover bg-center"></div>
      <div className="relative max-w-6xl mx-auto px-4 text-center">
        <div className="inline-block rounded-[2rem] bg-black/30 px-8 py-10 backdrop-blur-sm shadow-2xl">
          <p className="text-sm uppercase tracking-[0.4em] text-cream mb-4">Traditional Food</p>
          <h1 className="text-4xl md:text-5xl font-extrabold leading-tight mb-6">Pecel Madiun: A Rich Taste of Java</h1>
          <p className="text-base md:text-lg text-cream-dark max-w-2xl mx-auto mb-8">
            Explore the warm flavors of Javanese pecel Madiun, where fresh vegetables, spicy peanut sauce, and crispy side dishes come together in a beautiful red and cream feast.
          </p>
          <a href="#menu" className="inline-block bg-cream text-[#7C2D12] px-8 py-3 rounded-full font-semibold shadow-lg hover:bg-[#f4d6c0] transition">
            Discover the Menu
          </a>
        </div>
      </div>
    </section>
  );
}

export default Hero;
